export default __webpack_public_path__ + "static/macbook-pcr-calculator-2942012349a861a5700445dd139c8f3f.png";